import { DataSearchSource } from "../stores-js/datasearchsource";

export class QueryService2 {
    constructor() {
        this.currentQueryTags = {};
        this.currentQueryTypes = {};
    }

    addTag(tag) {
        if (!(tag.toString() in this.currentQueryTags)) {
            this.currentQueryTags[tag.toString()] = {
                value: tag.toString(),
                operator: DataSearchSource.AND,
            };
        }
    }
    addTagWithCategory(tag, category) {
        if (!(tag.toString() in this.currentQueryTags)) {
            this.currentQueryTags[tag.toString()] = {
                value: tag.toString(),
                category: category,
                operator: this.belongsToSameCategory(category) ? DataSearchSource.OR : DataSearchSource.AND,
            };
        }
    }

    getTagArray() {
        return Object.values(this.currentQueryTags);
    }

    removeTag(tag) {
        if (tag in this.currentQueryTags) delete this.currentQueryTags[tag];
    }

    addType(type) {
        if (!(type.toString() in this.currentQueryTypes)) {
            this.currentQueryTypes[type.toString()] = {
                value: type.toString(),
                operator: DataSearchSource.OR,
            };
        }
    }

    getTypeArray() {
        return Object.values(this.currentQueryTypes);
    }

    removeType(type) {
        if (type in this.currentQueryTypes) delete this.currentQueryTypes[type];
    }

    resetTypes(types) {
        this.currentQueryTypes = {};

        for (const type of types) {
            this.addType(type);
        }
    }
    belongsToSameCategory(cat) {
        if (this.currentQueryTags) {
            for (const value of Object.values(this.currentQueryTags)) {
                if (cat === value.category) {
                    return true;
                }
            }
        } else {
            return true;
        }
        return false;
    }
}
